<template>
  <div class="mineBox">
    <div class="mineCard">
      <el-card shadow="always" :body-style="{ padding: '20px' }">
        <div slot="header" class="header">
          <div class="headerTitle">
            账户余额（元）
          </div>
          <div class="headerContent">
            <span
              >￥<i class="MyData">{{ handleControlNumber(MyData || 0, 2) }}</i></span
            >
            <span @click="tixian" class="txbutton">立即提现</span>
          </div>
        </div>
        <div class="bindWechart" @click="bindWechat">
          <img
            src="@/assets/image/svg/weChart.svg"
            alt=""
            style="width: .6944rem;height: .6944rem;"
          />
          绑定微信提现
        </div>
      </el-card>
    </div>
    <tixian ref="tixian"></tixian>
  </div>
</template>
<script>
import { getUserInfo, getMyData, getDayProfit } from "@/api/newApi";
import tixian from "@/components/global/tixian";
import { Toast } from "vant";
import {digitUtil} from "@/utils/utils";
export default {
  components: {
    tixian,
  },
  data() {
    return {
      MyData: 0,
      tixianUnavailble: false,
      todaymoney: 0,
    };
  },
  mounted() {
    getMyData().then((res) => {
      if (res.data) {
        this.MyData = res.data.amount;
      }
      if (!this.MyData) {
        this.tixianUnavailble = true;
      }
    });
    getDayProfit().then((res) => {
      this.todaymoney = res.data.sumOrdergold;
    });
  },
  methods: {
    handleControlNumber: digitUtil,
    tixian() {
      if (this.tixianUnavailble) {
        Toast("当前可提现余额为0，无法提现");
        return false;
      }
      getUserInfo().then((res) => {
        if (res.message.status == 200 && res.data.weixinOpenid != null) {
          this.$router.push({
            path: "/admin/tixian",
          });
        } else {
          Toast("请先绑定微信");
        }
      });
    },
    bindWechat() {
      if (this.tixianUnavailble) {
        Toast("当前可提现余额为0，无法绑定");
        return false;
      }
      var that = this;
      this.$dialog({
        title: "是否绑定此微信为提现微信",
        closeBtn: false, //显式右上角关闭按钮
        onOkBtn(event) {
          //确定按钮点击事件
          that.$router.push("/admin/bind_wechat");
          this.close(); //关闭对话框
        },
        onCancelBtn(event) {
          //取消按钮点击事件，默认行为关闭对话框
          Toast("取消绑定");
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.mineBox {
  padding: 0.2667rem 0.4rem;

  .header {
    color: #444;

    .headerTitle {
      font-size: 0.32rem;
    }

    .headerContent {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 0.2778rem 0;

      .txbutton {
        display: inline-block;
        color: #e6eafb;
        background-color: #134fc5;
        border-radius: 0.1389rem;
        padding: 0.1111rem 0.2778rem;
      }

      > span {
        color: #134fc5;
      }

      .MyData {
        font-size: 0.5556rem;
      }
    }
  }

  .bindWechart {
    color: #444444;
    font-size: 0.3472rem;
    display: flex;
    align-items: center;

    img {
      margin-right: 0.1389rem;
    }
  }
}

::v-deep .el-card__header {
  padding: 0 !important;
  margin: 0.2778rem;
  border-bottom: 1px solid #161e3f;
}

::v-deep .mu-card-header {
  padding: 0.2778rem 0 !important;
}
</style>
